import { Animations } from "/app/libraries/arcana/src/blocks/AnimatedWrapper/index.ts"
import { TabsWithBorder } from "/app/libraries/arcana/src/blocks/Tabs/Templates/index.ts"
import { TabWithGradientBackground } from "/app/libraries/arcana/src/atoms/Tab/Templates/index.ts"

import { useUnit } from 'effector-react'
import { AuthTab } from './index.h'
import { $selectedTab, selectEmailTab, selectPhoneTab } from './model'
import { $authFormsTabsTranslations } from './translations'

export const AuthTabs = () => {
  const tabsTranslations = useUnit($authFormsTabsTranslations)
  const selectedTab = useUnit($selectedTab)
  const enterPhoneTab = useUnit(selectPhoneTab)
  const enterEmailTab = useUnit(selectEmailTab)

  return (
    <TabsWithBorder>
      <TabWithGradientBackground
        title={tabsTranslations.phone}
        selected={selectedTab === AuthTab.Phone}
        onClick={enterPhoneTab}
        transitionName={Animations.SelectionTabs}
      />
      <TabWithGradientBackground
        title={tabsTranslations.email}
        selected={selectedTab === AuthTab.Email}
        onClick={enterEmailTab}
        transitionName={Animations.SelectionTabs}
      />
    </TabsWithBorder>
  )
}
